/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { CharityDapp } from "./CharityDapp";

export class CharityDappFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<CharityDapp> {
    return super.deploy(overrides || {}) as Promise<CharityDapp>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CharityDapp {
    return super.attach(address) as CharityDapp;
  }
  connect(signer: Signer): CharityDappFactory {
    return super.connect(signer) as CharityDappFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CharityDapp {
    return new Contract(address, _abi, signerOrProvider) as CharityDapp;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "proposalAddress",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "Sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "message",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "Comments",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "proposalAddress",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "donorAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Donated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "proposalAddress",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_campaigner",
        type: "address",
      },
    ],
    name: "ProposalAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "proposalAddress",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalAproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "proposalAddress",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalClaimed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "Admin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "poolDonation",
        type: "uint256",
      },
    ],
    name: "CharityPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
    ],
    name: "Support",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "addComments",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "addToCharityPool",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
    ],
    name: "approveProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "campaigns",
    outputs: [
      {
        internalType: "string",
        name: "PraposalHash",
        type: "string",
      },
      {
        internalType: "string",
        name: "proposalTitle",
        type: "string",
      },
      {
        internalType: "address",
        name: "Campaigner",
        type: "address",
      },
      {
        internalType: "bool",
        name: "fullExtraction",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "proposalApproved",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "fundRaisingDeadline",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fundingGoal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "raisedFunds",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "claimedFunds",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "support",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
    ],
    name: "claimFunds",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dayswappers",
    outputs: [
      {
        internalType: "contract IDayswappers",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_proposalAddress",
        type: "bytes32",
      },
    ],
    name: "donate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "donateToCharityPool",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getCharityPool",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "kycDapp",
    outputs: [
      {
        internalType: "contract IKycDapp",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "ipfsHash",
        type: "string",
      },
      {
        internalType: "string",
        name: "_title",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_fundingGoal",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_fullExtraction",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_fundRaisingDeadline",
        type: "uint256",
      },
    ],
    name: "newCampaign",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nrtManager",
    outputs: [
      {
        internalType: "contract INRTManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "prepaidEs",
    outputs: [
      {
        internalType: "contract IPrepaidEs",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "randomnessManager",
    outputs: [
      {
        internalType: "contract RandomnessManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddressStrict",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsername",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsernameStrict",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_kycDapp",
        type: "address",
      },
    ],
    name: "setKycDapp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "supportUser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyClub",
    outputs: [
      {
        internalType: "contract ITimeAllyClub",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyManager",
    outputs: [
      {
        internalType: "contract ITimeAllyManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyPromotionalBucket",
    outputs: [
      {
        internalType: "contract ITimeAllyPromotionalBucket",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validatorManager",
    outputs: [
      {
        internalType: "contract IValidatorManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
